/* Gift entitlement metadata; paid Shopify variants keep their catalogue prices. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.GosGiftCore = api;
})(typeof window === 'object' ? window : globalThis, function () {
  'use strict';
  const POINTS = [999,1499,1999,2499,2999,3499,3999,4499];
  const RULES = {1:{paid:1,gifts:0,total:1},2:{paid:2,gifts:1,total:3},3:{paid:3,gifts:4,total:7}};
  const rule = paid => {
    if (!Object.hasOwn(RULES,paid)) throw new Error('Offre inconnue.');
    return {...RULES[paid]};
  };
  const title = unit => `${unit.title}${unit.variantTitle && unit.variantTitle !== 'Default Title' ? ` — ${unit.variantTitle}` : ''}`;
  function offer(units, paid) {
    const spec=rule(paid);
    if(!Array.isArray(units)||units.length!==spec.total) throw new Error('Complétez votre sélection.');
    for(const u of units) {
      if(!u || !Number.isSafeInteger(u.id)||u.id<1||!POINTS.includes(u.price)||u.available!==true||typeof u.title!=='string'||!u.title||!/^[-a-z0-9]+$/.test(u.handle)) throw new Error('Un article est indisponible ou incompatible avec cette offre.');
    }
    const counts=new Map();
    for(const u of units) {
      counts.set(u.id,(counts.get(u.id)||0)+1);
      if(Number.isInteger(u.stock) && counts.get(u.id)>u.stock) throw new Error(`Stock insuffisant : ${u.title}.`);
    }
    // Highest-priced units remain paid. Stable ties give the last slots for free.
    const ranked=units.map((u,index)=>({u,index})).sort((a,b)=>b.u.price-a.u.price||a.index-b.index);
    const paidIndexes=ranked.slice(0,spec.paid).map(x=>x.index).sort((a,b)=>a-b);
    const giftIndexes=ranked.slice(spec.paid).map(x=>x.index).sort((a,b)=>a-b);
    return {...spec,paidIndexes,giftIndexes,totalPrice:paidIndexes.reduce((sum,i)=>sum+units[i].price,0)};
  }
  function cartItems(units,paid,group) {
    const result=offer(units,paid);
    if(!result.gifts) return [{id:units[0].id,quantity:1}];
    if(typeof group!=='string'||!/^[-a-zA-Z0-9]{8,80}$/.test(group)) throw new Error('Référence de lot invalide.');
    const giftUnits=result.giftIndexes.map(i=>units[i]);
    const plan={version:1,paid,currency:'EUR',paidIds:result.paidIndexes.map(i=>units[i].id),giftIds:giftUnits.map(u=>u.id)};
    return result.paidIndexes.map((index,slot)=>{
      const properties={Offre:`${paid} achetés + ${result.gifts} offert${result.gifts>1?'s':''}`,_gos_gift_group:group,_gos_gift_plan:JSON.stringify(plan),_gos_gift_slot:String(slot)};
      // Public properties travel to native checkout. The complete group is
      // checked before checkout, including its anchor, quantities and prices.
      if(slot===0) giftUnits.forEach((u,i)=>{properties[`Offert ${i+1}`]=title(u);});
      return {id:units[index].id,quantity:1,properties};
    });
  }
  function validateGroup(lines,catalog) {
    try {
      const raw=lines[0]?.properties?._gos_gift_plan;
      const plan=JSON.parse(raw);
      const spec=rule(plan.paid);
      if(plan.version!==1||plan.currency!=='EUR'||!spec.gifts||lines.length!==spec.paid||plan.paidIds.length!==spec.paid||plan.giftIds.length!==spec.gifts) throw new Error();
      const slots=new Set();
      for(const line of lines) {
        const slot=Number(line.properties._gos_gift_slot);
        if(!Number.isInteger(slot)||slot<0||slot>=spec.paid||slots.has(slot)||line.quantity!==1||line.properties._gos_gift_plan!==raw||Number(line.variant_id||line.id)!==plan.paidIds[slot]||line.properties._gos_gift_group!==lines[0].properties._gos_gift_group) throw new Error();
        slots.add(slot);
      }
      const ids=[...plan.paidIds,...plan.giftIds];
      const units=ids.map(id=>catalog.get(Number(id)));
      const result=offer(units,plan.paid);
      if(result.paidIndexes.some((slot,index)=>slot!==index)) throw new Error();
      for(const line of lines) {
        const unit=catalog.get(Number(line.variant_id||line.id));
        if(line.final_price!==unit.price||line.original_price!==unit.price) throw new Error();
        const visible=Object.keys(line.properties).filter(k=>k.startsWith('Offert '));
        if(Number(line.properties._gos_gift_slot)===0) {
          if(visible.length!==spec.gifts) throw new Error();
          for(let i=0;i<plan.giftIds.length;i++) if(line.properties[`Offert ${i+1}`]!==title(units[plan.paidIds.length+i])) throw new Error();
        } else if(visible.length) throw new Error();
      }
      return {valid:true,...result,giftUnits:units.slice(spec.paid),group:lines[0].properties._gos_gift_group};
    } catch (_) {return {valid:false,message:'Ce lot a changé. Retirez-le puis composez-le à nouveau pour conserver les cadeaux.'};}
  }
  return {POINTS,rule,offer,cartItems,validateGroup,title};
});
